import { Component } from '@angular/core';
import { HisCoreSharedModule } from 'hisng';
import { RouterOutlet } from '@angular/router';

@Component({
    standalone: true,
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [HisCoreSharedModule, RouterOutlet]
})
export class AppComponent {
}
